import { z } from 'zod';
import { FLOW_MEDICAL_NECESSITY_CHECK_INSURANCE_PROVIDER_OPTIONS } from './insuranceProviders.js';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowMedicalNecessityCheckBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.MedicalNecessityCheck),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
    config: z.object({
        insuranceProvider: z
            .string({
            message: 'Insurance Provider is required',
        })
            .min(1),
        diagnoses: z.string({ message: 'Diagnosis Codes is required' }).min(1),
        procedureCptCodes: z.string({ message: 'Procedure CPT Codes is required' }).min(1),
        procedureServiceDate: z.string().optional(),
    }),
});
export const FlowMedicalNecessityCheckDiagnosesSchema = z.array(z.string());
export const FlowMedicalNecessityCheckProcedureCptCodesSchema = z.array(z.string());
export const FlowMedicalNecessityCheckProcedureServiceDateSchema = z.iso.date();
export const FlowMedicalNecessityCheckInsuranceProviderSchema = z.enum(FLOW_MEDICAL_NECESSITY_CHECK_INSURANCE_PROVIDER_OPTIONS);
//# sourceMappingURL=config.js.map